import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSliderTickMark = styled.div.withConfig({
  displayName: "SliderTickMark__StyledSliderTickMark",
  componentId: "yg83t9-0"
})(({
  $backgroundColor,
  $borderColor,
  $shorthandSize,
  theme
}) => {
  return {
    backgroundColor: theme.color[$backgroundColor],
    borderColor: $borderColor !== undefined ? theme.color[$borderColor] : undefined,
    blockSize: $shorthandSize === 'lg' ? '20px' : '14px',
    inlineSize: $shorthandSize === 'lg' ? '3px' : '2px'
  };
});
export const SliderTickMark = ({
  currentSliderValue,
  value,
  min,
  shorthandSize,
  readOnly,
  disabled
}) => {
  const getBackgroundColor = () => {
    if (readOnly) {
      return 'border-core-default';
      // @ts-expect-error 'currentSliderValue' is possibly 'null'
    } else if (min <= value && value <= currentSliderValue) {
      if (disabled) {
        return 'border-core-default';
      }
      return 'icon-interactive-default';
      // @ts-expect-error 'currentSliderValue' is possibly 'null'
    } else if (value <= currentSliderValue && disabled) {
      return 'border-core-default';
    }
    return 'border-core-default';
  };
  return /*#__PURE__*/_jsx(StyledSliderTickMark, {
    $backgroundColor: getBackgroundColor(),
    $borderColor:
    // @ts-expect-error 'currentSliderValue' is possibly 'null'
    value <= currentSliderValue && disabled ? 'border-core-default' : undefined,
    $shorthandSize: shorthandSize
  });
};